import { Box, Grid } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormField from '../FormField';

interface QrCodeSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
}

export default function QrCodeSection({ control, errors }: QrCodeSectionProps) {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      {/*  <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>
        {t('createGuiVersionPage.qrCode')}
      </Typography> */}

      <Box display="flex" gap={2} width="100%">
        <Box flex="1">
          <FormField
            name="qrCodeEn"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.qrCodeEn')}
          />
        </Box>
        <Box flex="1">
          <FormField
            name="qrCodeHu"
            control={control}
            errors={errors}
            label={t('createGuiVersionPage.qrCodeHu')}
          />
        </Box>
      </Box>
    </Grid>
  );
}
